/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
import { useEffect, useState } from 'react';
import PropTypes, { number } from 'prop-types';
import { useParams } from 'react-router-dom';
import { Loader, TextArea } from 'ypf-pas-general-ui-components';

import ProvidersTable from '../../../../components/ProvidersTable/ProvidersTable';
import { getRequestTo } from '../../../../services/serviceRequest';
import './ReassignProvider.scss';
import DuplicatedRequestTable from '../../../../components/DuplicatedRequestModal/DuplicatedRequestTable/DuplicatedRequestTable';

const ReassignProvider = (props) => {
  const {
    numero,
    proveedorAsignado,
    message,
    setMessage,
    isChecked,
    setIsChecked,
    setProviderData,
    idsEventoPozo,
    idService,
    tipoAsignacionEnum,
    setShowTable,
    showTable,
    tipoUbicacion,
    ubicationStr
  } = props;

  const { id } = useParams();

  const [loaderProviders, setLoaderProviders] = useState(false);
  const [duplicatedData, setDuplicatedData] = useState([]);

  const [providers, setProviders] = useState([]);

  const getDetailsSolicitateTo = async () => {
    setLoaderProviders(true);
    const detailsHeader = await getRequestTo(id);

    setProviders(detailsHeader);
    setLoaderProviders(false);
  };

  useEffect(() => {
    getDetailsSolicitateTo();
  }, [id]);

  const handleMessage = (e) => {
    e.preventDefault();
    setMessage(e.target.value);
  };

  return (
    <div>
      {loaderProviders && <Loader show={loaderProviders} text="CARGANDO ..." />}
      <div className="wrapper_header">
        <p>
          {' '}
          Solicitud de servicio N° {numero} asignada al proveedor
          <strong>{` ${proveedorAsignado.nombre}`}</strong>
        </p>
        <br />
        <p>
          Al reasignar la solicitud de servicio se le informará al proveedor anterior el motivo de
          su remoción
        </p>

        <TextArea
          className="text_area"
          label="Comentario"
          maxLength={512}
          name="comment"
          onChange={(e) => handleMessage(e)}
          placeholder="Motivo de remoción"
          resize={false}
          value={message}
        />
      </div>
      <div className="title">Asignación de nuevo proveedor</div>

      <ProvidersTable
        calledFrom="reassign"
        canChangeValue
        idRequest={id}
        idService={idService}
        idsEventoPozo={idsEventoPozo}
        isChecked={isChecked}
        providers={providers}
        setDuplicatedData={setDuplicatedData}
        setIsChecked={setIsChecked}
        setProviderData={setProviderData}
        setShowTable={setShowTable}
        tipoAsignacionEnum={tipoAsignacionEnum}
        tipoUbicacion={tipoUbicacion}
        ubicacionStr={ubicationStr}
      />
      {showTable && <DuplicatedRequestTable data={duplicatedData} />}
    </div>
  );
};

ReassignProvider.propTypes = {
  numero: PropTypes.string.isRequired,
  proveedorAsignado: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired,
  message: PropTypes.string,
  setMessage: PropTypes.func,
  isChecked: PropTypes.number,
  setIsChecked: PropTypes.func,
  setProviderData: PropTypes.func,
  idsEventoPozo: PropTypes.arrayOf(number).isRequired,
  idService: PropTypes.number.isRequired,
  tipoAsignacionEnum: PropTypes.number.isRequired,
  setShowTable: PropTypes.func.isRequired,
  showTable: PropTypes.bool.isRequired,
  tipoUbicacion: PropTypes.number.isRequired,
  ubicationStr: PropTypes.string.isRequired
};

ReassignProvider.defaultProps = {
  message: '',
  setMessage: () => {
    /* empty */
  },
  isChecked: null,
  setIsChecked: () => {
    /* empty */
  },
  setProviderData: () => {
    /* empty */
  }
};

export default ReassignProvider;
